import { render, staticRenderFns } from "./Menu-en.vue?vue&type=template&id=69299b82&scoped=true"
import script from "./Menu-en.vue?vue&type=script&lang=js"
export * from "./Menu-en.vue?vue&type=script&lang=js"
import style0 from "./Menu-en.vue?vue&type=style&index=0&id=69299b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69299b82",
  null
  
)

export default component.exports